<template>
  <div class="product-detail-slider-wrapper">
    <VueSlickCarousel v-bind="settings" @afterChange="changeIndex">
      <div
        v-for="(item, index) in banners"
        :key="index"
        class="product-detail-slider-item"
      >
        <img class="img-fluid" :src="item" alt="image">
      </div>
    </VueSlickCarousel>
    <div class="product-detail-slider-counter">
      {{ currentIndex }}/{{banners.length}}
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  props: {
    banners: {
      type: Array,
      optional: true
    },
  },
  data(){
    return {
      settings: {
        speed: 500,
        arrows: true,
        centerMode: true,
        centerPadding: '16px',
        infinite: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      currentIndex: 1
    }
  },
  methods: {
    changeIndex(index) {
      this.currentIndex = index + 1;
    },
  },
   components: {
    VueSlickCarousel
  }
}
</script>